<template>
  <pdl-dialog
    id="customization-send-to-retailer-dialog"
    v-model:visible="isSubmitToRetailerDialogOpen"
    qaid="customization-send-to-retailer-dialog"
    :title="$t('projectOne.buildDreamBike')"
    :z-index="9999"
    :close-dialog-tool-tip="$t('popup.close')"
    top="5vh"
    @opened="focusTrapSubmitToRetailerDialog"
    @keydown="handleKeydown"
    @close="closeModal"
  >
    <customization-submit-to-retailer-body />
  </pdl-dialog>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {PdlDialog} from '@pedal/pdl-dialog';
import CustomizationSubmitToRetailerBody from '@/components/containers/buy-zone/customization/CustomizationSubmitToRetailerBody.vue';
import {focusTrap, getAllFocusableElements} from '@/utils/accessibility/a11y-utils';

export default {
  name: 'CustomizationSubmitToRetailerDialog',
  components: {
    PdlDialog,
    CustomizationSubmitToRetailerBody,
  },
  data() {
    return {
      focusableElements: [],
    };
  },
  computed: {
    ...mapState('bikeCustomization', ['isSubmitToRetailerDialogOpen']),
  },
  watch: {
    isSubmitToRetailerDialogOpen(val) {
      this.setIsDialogOpen(val);
    },
  },
  methods: {
    ...mapMutations('bikeCustomization', [
      'setIsSubmitToRetailerDialogOpen',
      'setHasQueuedSubmitToRetailerAction',
      'setIsDialogOpen',
    ]),

    closeModal() {
      this.setHasQueuedSubmitToRetailerAction(false);
      this.setIsSubmitToRetailerDialogOpen(false);
    },
    focusTrapSubmitToRetailerDialog() {
      const dialog = document.querySelector('#customization-send-to-retailer-dialog');
      this.focusableElements = getAllFocusableElements(dialog);
    },
    handleKeydown(event) {
      focusTrap(event, this.focusableElements);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.pdl-dialog) {
  display: flex;
  flex-direction: column;
  max-height: 90dvh;
}

:deep(.pdl-dialog__body) {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  flex: 1;
}

#customization-send-to-retailer-dialog {
  overflow: hidden;
}
</style>
